module.exports = __webpack_public_path__ + "static/media/8 Minuts 12th May 2022.2547fc27.pdf";